import { Button, Grid2 as Grid } from "@mui/material"
import { Field, Formik } from "formik"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import * as yup from "yup"
import { Assemblaggio } from "../../types"
import { transformErrorForForm } from "../../utils/utils"
import { FormInDialogProps } from "../DialogForm"
import { FormikTextField } from "./formsHelpers"

export default function AssemblaggioForm({ item, save, ref, language }: FormInDialogProps<Assemblaggio>) {
  const { t, i18n } = useTranslation()
  const currentLanguage = language ?? i18n.language
  const noteField = currentLanguage === "en" ? "note_en" : "note_it"

  const initialValues = useMemo(() => {
    return item
      ? {
          ...item,
          note_it: item.note_it ?? "",
          note_en: item.note_en ?? "",
        }
      : {
          id: undefined,
          nome: "",
          note_it: "",
          note_en: "",
        }
  }, [item])

  const schema = useMemo(
    () =>
      yup.object().shape({
        nome: yup.string().required().label(t("assemblaggio.nome")),
      }),
    [t],
  )

  return (
    <Formik
      validationSchema={schema}
      initialValues={initialValues}
      enableReinitialize
      onSubmit={(values, formikBag) => {
        const payload = {
          id: values.id,
          nome: values.nome,
          note_it: values.note_it ?? "",
          note_en: values.note_en ?? "",
        }
        return save(payload as Assemblaggio).catch((e) => {
          const localError = transformErrorForForm(e)
          formikBag.setErrors(localError)
        })
      }}
    >
      {({ handleSubmit }) => (
        <form onSubmit={handleSubmit} noValidate>
          <Grid container spacing={1} sx={{ py: 2 }}>
            <Grid size={12}>
              <Field
                component={FormikTextField}
                name="nome"
                label={t("assemblaggio.nome")}
                required
                margin="dense"
                fullWidth
                variant="outlined"
              />
            </Grid>
            <Grid size={12}>
              <Field
                component={FormikTextField}
                name={noteField}
                label={t(`assemblaggio.${noteField}`)}
                margin="dense"
                fullWidth
                multiline
                minRows={4}
                variant="outlined"
              />
            </Grid>
          </Grid>
          <Button ref={ref} type="submit" color="primary" sx={{ display: "none" }}></Button>
        </form>
      )}
    </Formik>
  )
}
